export const isTestEmail = (email?: string | null): boolean => {
  return Boolean(email?.startsWith('test+') && email?.endsWith('soraban.com'));
};
